import { HttpClient, HttpHeaders } from "@angular/common/http";
import { booleanAttribute, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";
import { MenuComprador, MenuCompradorResponse } from "../interfaces/menu-comprador.interface";
import { AuthService } from "./auth.service";
import { EmpresaBrandig } from "../interfaces/empresa-brandig.interface";
import { AmbienteSitio } from "../enums/ambiente-sitio";
import { Apis } from "../enums/apificado-api";
import { IncompatibleBrowserRequest } from "../interfaces/incompatible-browser.interface";

@Injectable({
  providedIn: "root",
})
export class MenuBffService {
  constructor(
    private http: HttpClient,
    private auth: AuthService,
  ) {}

  public obtenerConfiguracionWhiteLabel(
    dominio: number,
    ambiente: number,
  ): Observable<EmpresaBrandig> {
    var path = `${environment.urlApiMenuBff}api/menu/ConfiguracionWhiteLabel?domain=${dominio}&env=${ambiente}`;
    return this.http.get<EmpresaBrandig>(path).pipe(map((r) => r));
  }

  public obtenerAmbienteOrigen(url: string): AmbienteSitio {
    if (url.includes(".iconstruye.com") || url.includes(".agilice.com")) {
      return AmbienteSitio.PROD;
    } else if (url.includes(".iconstruye.cl") || url.includes(".agilice.cl")) {
      return AmbienteSitio.QA;
    } else {
      return AmbienteSitio.DEV;
    }
  }

  /**
   * @param idPais Código ya validado (p. ej. ISO alpha-2 en mayúsculas); si se omite, no se añade query.
   */
  public obtenerMenuComprador(
    idPais?: string,
    registro: boolean = false,
  ): Observable<MenuCompradorResponse> {
    const path = "api/menu";
    var tienePais = idPais != null && idPais !== "";
    var url = tienePais
      ? `${path}?idPais=${encodeURIComponent(idPais!)}`
      : path;

    if (registro) {
      url += `${tienePais ? "&" : "?"}registro=true`;
    }

    var usuario = this.auth.getIdentidadUsuario();
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Cache-Control": "no-cache"
      }),
    };
    return this.http
      .get<MenuCompradorResponse>(environment.urlApiMenuBff + url, httpOptions)
      .pipe(map((r) => r ?? { menu: [], bannerId: [] }));
  }

  public reportarNavegadorIncompatible(
    payload: IncompatibleBrowserRequest
  ): Observable<void> {
    const url = `${environment.urlApiMenuBff}api/banner/incompatible-browser`;
    return this.http.put<void>(url, payload);
  }
}
